export default __webpack_public_path__ + "static/media/nwxtsz.610b79d9.png";